import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

export const ProModeIcon = (
  props: SVGProps<SVGSVGElement> & { size?: Unit }
) => {
  const { size = 3 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 24"
      fill="none"
      style={{ height: unitMapping[size], width: 'auto' }}
      {...props}
    >
      <path
        d="M7.61276 0.233622L8.43518 1.24408L8.43423 1.32956L14.2976 9.15874L15.3584 8.50536L15.535 8.88524L18.4914 13.8473L18.5436 19.8902L14.402 22.2207L12.4552 15.5074L9.4371 14.0363L6.15405 15.2424L2.75798 14.0363V9.20338L0.0380859 8.21001V4.74462L2.75798 3.06653V2.98011L2.81021 3.03424L2.82256 3.02759L3.76179 3.99912V4.01526L4.63835 4.91936V1.71703L7.42282 0L7.43802 0.018044V0L7.61276 0.233622ZM3.73045 13.3487L6.14835 14.2082L9.10186 13.1237L9.49028 12.9803L13.2691 14.8227L14.9937 20.7715L17.5654 19.3242L17.5208 14.1189L14.9908 9.87291L14.8076 9.98687L14.0516 10.4522L7.45796 1.64865V1.58407L7.20724 1.27542L5.61083 2.2593V7.31921L2.78932 4.40938V4.39228L2.66586 4.26503L1.01056 5.28689V7.52909L3.73045 8.52341V13.3487Z"
        fill="currentColor"
      />
      <path
        d="M4.68004 9.5104L0 4.68221V15.7378L4.68004 21.7364L6.67929 15.7378L9.69743 17.2092L11.2442 24L15.7337 21.3969V15.5492L12.5647 10.2297V12.2292L4.68004 1.70183V9.5104Z"
        fill="currentColor"
      />
      <path
        d="M15.3585 8.55092L15.8595 9.39237L13.0598 11.0596L12.5587 10.2182L15.3585 8.55092Z"
        fill="currentColor"
      />
    </svg>
  );
};
